if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('change', this.onVariantChange);

        this.selectors = {
          variantIdInput: 'input[name="id"]',
        };
        this.sectionId = this.dataset.section;
        this.container = this.closest(`#ProductInfo-${this.sectionId}`);
      }

      connectedCallback() {
        this.getVariantData();
        const variantIdInput = this.container && this.container.querySelector(this.selectors.variantIdInput);
        this.currentVariant = variantIdInput
          ? this.variantData.find((variant) => variant.id === Number(variantIdInput.value))
          : false;

        const colorInput = this.querySelector('input[type="radio"][name="Farbe"]:checked');
        if (colorInput) {
          const selectedSwatchValue = this.querySelector('[data-selected-swatch-value="Farbe"]');
          if (selectedSwatchValue) {
            selectedSwatchValue.textContent = this.colorLabel(colorInput);
          }
        }

        // —— NEW: create hidden property for color code ——
        if (!this.colorCodeHidden) {
          this.colorCodeHidden = document.createElement('input');
          this.colorCodeHidden.type = 'hidden';
          this.colorCodeHidden.name = 'properties[Color code]';
          this.colorCodeHidden.setAttribute('form', `product-form-${this.sectionId}`);
          this.appendChild(this.colorCodeHidden);
        }
        // initialize from preselected swatch
        if (colorInput) {
          this.colorCodeHidden.value = colorInput.getAttribute('data-color-code') || '';
        }

        // —— NEW: bind size rendering to color changes ——
        // —— bind size rendering to colour swatch changes —————————————
        this.addEventListener('focusin', (event) => {
          const input = event.target.closest('.size-qty-table__input');
          if (input) input.select();
        });
        this.addEventListener('focusout', (event) => {
          const input = event.target.closest('.size-qty-table__input');
          if (input && input.value === '') input.value = '0';
        });

        this.querySelectorAll('input[type="radio"][data-available-sizes], input[type="radio"][name="Farbe"]').forEach(input => {

          // when the user picks a colour
          input.addEventListener('change', () => {
            // `data-available-sizes` is always correct for the clicked swatch
            this.renderSizes(input.dataset.availableSizes);
            // sync hidden color code property
            this.colorCodeHidden.value = input.getAttribute('data-color-code') || '';
          });

          // render sizes for the colour that is pre-selected on initial page load
          if (input.checked) {
            this.renderSizes(input.dataset.availableSizes);
            // ensure hidden property is set on load
            this.colorCodeHidden.value = input.getAttribute('data-color-code') || '';
          }
        });
                      
        // —— size & length warning on Add click & Submit ——
        const addButton   = this.container.querySelector('button[name="add"]');
        const sizeWarning = document.getElementById(`size-warning-${this.sectionId}`);
        const lengthWarning = document.getElementById(`length-warning-${this.sectionId}`);
        
        const validateForm = (e) => {
          let hasError = false;
          
          // Check size selection (pills or qty table)
          const sizeTableInputs = this.querySelectorAll('.size-qty-table__input');
          const sizeSampleInputs = this.querySelectorAll('.size-qty-table__sample-input');
          const sizeInputs = this.querySelectorAll('input[name="properties[_Size]"]');
          const sizeRequired = sizeTableInputs.length > 0 || sizeInputs.length > 0;
          const sizeSelected = sizeTableInputs.length > 0
            ? Array.from(sizeTableInputs).some((i) => parseInt(i.value, 10) > 0)
              || Array.from(sizeSampleInputs).some((i) => i.checked)
            : Array.from(sizeInputs).some((i) => i.checked);
    
          if (sizeRequired && !sizeSelected) {
            hasError = true;
            if (sizeWarning) {
              sizeWarning.textContent = sizeTableInputs.length
                ? sizeWarning.dataset.qtyRequired || sizeWarning.textContent
                : sizeWarning.dataset.sizeRequired || sizeWarning.textContent;
              sizeWarning.classList.remove('hidden');
            }
          } else {
            if (sizeWarning) sizeWarning.classList.add('hidden');
          }
          
          // Check length selection
          const lengthContainer = document.getElementById('dynamic-length-buttons');
          const lengthInputs = lengthContainer ? lengthContainer.querySelectorAll('input[type="radio"]') : [];
          const lengthRequired = lengthInputs.length > 0;
          const lengthSelected = Array.from(lengthInputs).some(i => i.checked);
          
          if (lengthRequired && !lengthSelected) {
            hasError = true;
            if (lengthWarning) lengthWarning.classList.remove('hidden');
          } else {
            if (lengthWarning) lengthWarning.classList.add('hidden');
          }
          
          if (hasError) {
            e.preventDefault();
            e.stopPropagation();
            // Scroll to warning if needed
            if (sizeWarning && !sizeWarning.classList.contains('hidden')) {
               sizeWarning.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else if (lengthWarning && !lengthWarning.classList.contains('hidden')) {
               lengthWarning.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
          }
        };

        if (addButton) {
          addButton.addEventListener('click', validateForm);
        }

        // Also validate on form submit (catches Enter key)
        const productForm = this.container.querySelector('form[is="product-form"]');
        if (productForm) {
            productForm.addEventListener('submit', validateForm);
        }
      
        if (this.useSizeTable()) {
          this.updateOptions();
          this.updateMasterId();
        }

        if (this.currentVariant) {
          this.updateMedia();
        }
      }
      


      useSizeTable() {
        return this.dataset.sizeDisplay === 'table';
      }

      parseAvailableSizes(sizesCSV) {
        const raw = String(sizesCSV || '').split(',').map((s) => s.trim()).filter(Boolean);
        const sizes = [];
        for (let i = 0; i < raw.length; i++) {
          const current = raw[i];
          const next = raw[i + 1];
          const third = raw[i + 2];
          if (/^\d+$/.test(current) && next === current && third === '5') {
            sizes.push(current, `${current}.5`);
            i += 2;
            continue;
          }
          sizes.push(current);
        }
        return [...new Set(sizes)];
      }

      renderSizes(sizesCSV) {
        const sizeContainer = this.querySelector('#dynamic-size-buttons')
          || document.getElementById('dynamic-size-buttons');
        if (!sizeContainer) {
          if (typeof window.renderSizes === 'function') window.renderSizes(sizesCSV);
          return;
        }
        if (!this.useSizeTable()) {
          if (typeof window.renderSizes === 'function') window.renderSizes(sizesCSV);
          return;
        }

        sizeContainer.innerHTML = '';
        sizeContainer.classList.add('size-qty-table');
        sizeContainer.dataset.sizeDisplay = 'table';
        if (!sizesCSV) return;

        const qtyLabel = sizeContainer.dataset.qtyLabel || '';
        const sampleRequest = sizeContainer.dataset.sampleRequest || '';
        if (!sizeContainer.querySelector('.size-qty-table__head')) {
          const head = document.createElement('div');
          head.className = 'size-qty-table__head';
          head.setAttribute('aria-hidden', 'true');
          head.innerHTML = `<span>${sizeContainer.dataset.sizeHead || ''}</span><span>${qtyLabel}</span><span>${sizeContainer.dataset.sampleHead || ''}</span>`;
          sizeContainer.appendChild(head);
        }
        this.parseAvailableSizes(sizesCSV).forEach((size) => {
          const inputId = `size-qty-${this.sectionId}-${size.toLowerCase().replace(/[^a-z0-9]/g, '-')}`;
          const sampleId = `${inputId}-sample`;
          const row = document.createElement('div');
          row.className = 'size-qty-table__row';

          const sizeLabel = document.createElement('label');
          sizeLabel.className = 'size-qty-table__size';
          sizeLabel.htmlFor = inputId;
          sizeLabel.textContent = size.toUpperCase();

          const input = document.createElement('input');
          input.className = 'size-qty-table__input';
          input.type = 'number';
          input.min = '0';
          input.step = '1';
          input.value = '0';
          input.id = inputId;
          input.dataset.size = size;
          input.inputMode = 'numeric';
          input.autocomplete = 'off';
          input.setAttribute('aria-label', `${qtyLabel} ${size.toUpperCase()}`.trim());

          const sampleLabel = document.createElement('label');
          sampleLabel.className = 'size-qty-table__sample';
          sampleLabel.htmlFor = sampleId;
          const sample = document.createElement('input');
          sample.className = 'size-qty-table__sample-input';
          sample.type = 'checkbox';
          sample.id = sampleId;
          sample.dataset.size = size;
          const sampleBox = document.createElement('span');
          sampleBox.className = 'size-qty-table__sample-box';
          sampleBox.setAttribute('aria-hidden', 'true');
          const sampleText = document.createElement('span');
          sampleText.className = 'visually-hidden';
          sampleText.textContent = `${sampleRequest} ${size}`.trim();
          sampleLabel.append(sample, sampleBox, sampleText);

          row.append(sizeLabel, input, sampleLabel);
          sizeContainer.appendChild(row);
        });
      }
      

      onVariantChange(event) {
        this.updateOptions(); // 1. Get latest selection
        this.updateMasterId(); // 2. Match correct variant immediately using updated options
      
        if (this.currentVariant?.metafields?.plytix?.available_sizes) {
          console.log('Plytix sizes for selected variant:', this.currentVariant.metafields.plytix.available_sizes);
        }
                

        console.log('Resolved options:', this.options);
        console.log('Matched variant:', this.currentVariant);
      

        this.updateSelectedSwatchValue(event);
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();
      
        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.updateURL();
          this.updateVariantInput(); // sets input[name="id"]
          this.updateMedia();
          this.renderProductInfo();
          this.updateShareUrl();
      
          document.dispatchEvent(
            new CustomEvent('variant:changed', {
              detail: {
                variant: this.currentVariant,
              },
            })
          );
        }
      }
      
      updateOptions() {
        this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
          if (element.classList.contains('product-form__input--size-table') || element.querySelector('.size-qty-table')) {
            return null;
          }
          if (element.tagName === 'SELECT') {
            return element.value;
          }
          if (element.tagName === 'FIELDSET') {
            return Array.from(element.querySelectorAll('input[type="radio"]')).find((radio) => radio.checked)?.value;
          }
        }).filter((value) => value != null);
      }

      updateMasterId() {
        const variants = this.getVariantData();
        if (this.useSizeTable()) {
          const color = this.options[0];
          this.currentVariant =
            variants.find((variant) => variant.option1 === color && variant.available)
            || variants.find((variant) => variant.option1 === color)
            || variants[0];
          this.syncSizeTableVariants(color);
          return;
        }
        this.currentVariant = variants.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return this.options[index] === option;
            })
            .includes(false);
        });
      }

      syncSizeTableVariants(color) {
        const variants = this.getVariantData();
        this.querySelectorAll('.size-qty-table__input').forEach((input) => {
          const size = input.dataset.size;
          const match = variants.find((variant) => {
            if (color && variant.option1 !== color) return false;
            return variant.options.includes(size);
          });
          const row = input.closest('.size-qty-table__row');
          if (!match) {
            input.removeAttribute('data-variant-id');
            input.disabled = true;
            row && row.classList.add('size-qty-table__row--unavailable');
            return;
          }
          input.dataset.variantId = String(match.id);
          input.disabled = !match.available;
          const sample = row && row.querySelector('.size-qty-table__sample-input');
          if (sample) {
            sample.dataset.variantId = String(match.id);
            sample.disabled = !match.available;
          }
          row && row.classList.toggle('size-qty-table__row--unavailable', !match.available);
        });
      }

      colorDisplayName(input) {
        const value = (input && input.value) || '';
        const colorCode = (input && input.getAttribute('data-color-code')) || '';
        if (!colorCode) return value;
        return value.replace(colorCode, '').trim() || value;
      }

      colorLabel(input) {
        const value = (input && input.value) || '';
        const colorCode = (input && input.getAttribute('data-color-code')) || '';
        if (this.dataset.showColorCode === 'false') {
          return this.colorDisplayName(input);
        }
        return colorCode ? `${colorCode} ${value}` : value;
      }

      updateSelectedSwatchValue({ target }) {
        const { name, value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const optionName = (name || '').toLowerCase();
          if (optionName === 'größe' || optionName === 'groesse' || optionName === 'size') return;

          const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
          if (selectedSwatchValue) {
            selectedSwatchValue.textContent =
              optionName === 'farbe' ? this.colorLabel(target) : value;
          }
        }
      }

      updateURL() {
        if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
      }

      updateShareUrl() {
        const shareButton = document.getElementById(`Share-${this.dataset.section}`);
        if (!shareButton || !shareButton.updateUrl) return;
        shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        );
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });

        this.toggleAddButton(!this.currentVariant.available);

      }

      updateVariantStatuses() {
        const selectedOptionOneVariants = this.variantData.filter(
          (variant) => this.querySelector(':checked').value === variant.option1
        );
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
          if (index === 0) return;
          const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
          const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
          const availableOptionInputsValue = selectedOptionOneVariants
            .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
            .map((variantOption) => variantOption[`option${index + 1}`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
      }

      setInputAvailability(elementList, availableValuesList) {
        elementList.forEach((element) => {
          const value = element.getAttribute('value');
          const availableElement = availableValuesList.includes(value);

          if (element.tagName === 'INPUT') {
            element.classList.toggle('disabled', !availableElement);
          } else if (element.tagName === 'OPTION') {
            element.innerText = availableElement
              ? value
              : FoxTheme.variantStrings.unavailable_with_option.replace('[value]', value);
          }
        });
      }

      updatePickupAvailability() {
        const pickUpAvailability = document.querySelector('pickup-availability');
        if (!pickUpAvailability) return;

        if (this.currentVariant && this.currentVariant.available) {
          pickUpAvailability.fetchAvailability(this.currentVariant.id);
        } else {
          pickUpAvailability.removeAttribute('available');
          pickUpAvailability.innerHTML = '';
        }
      }

      removeErrorMessage() {
        const section = this.closest('section');
        if (!section) return;

        const productForm = section.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
      }

      updateMedia() {
        const productMedia = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
        if (productMedia) {
          if (typeof productMedia.setActiveMedia === 'function') {
            productMedia.setActiveMedia(this.currentVariant);
          } else {
            this.timer = setInterval(() => {
              if (typeof productMedia.setActiveMedia === 'function') {
                clearInterval(this.timer);
                productMedia.setActiveMedia(this.currentVariant);
              }
            }, 100);
          }
        }
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant.id;
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`)
          .then((response) => response.text())
          .then((responseText) => {
            // Prevent unnecessary ui changes from abandoned selections.
            if (this.currentVariant.id !== requestedVariantId) return;

            let html = new DOMParser().parseFromString(responseText, 'text/html');

            // Need parse DOM from template for quick view.
            const quickView = html.querySelector('#MainProduct-quick-view__content');
            if (quickView) {
              html = quickView.content.cloneNode(true);
            }

            const priceDestination = document.getElementById(`price-${this.dataset.section}`);
            const priceSource = html.getElementById(`price-${sectionId}`);
            if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;

            const skuSource = html.getElementById(`Sku-${sectionId}`);
            const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
            if (skuSource && skuDestination) {
              skuDestination.innerHTML = skuSource.innerHTML;
              skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
            }

            const inventorySource = html.getElementById(`Inventory-${sectionId}`);
            const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);
            if (inventorySource && inventoryDestination) {
              const inventoryBarSource = inventorySource.querySelector('progress-bar');
              const inventoryBarDestination = inventoryDestination.querySelector('progress-bar');

              if (inventoryBarSource && inventoryBarDestination) {
                inventoryBarSource.dataset.from = inventoryBarDestination.dataset.value;
              }

              inventoryDestination.innerHTML = inventorySource.innerHTML;
            }

            const badgesSource = html.getElementById(`Badges-${sectionId}`);
            const badgesDestination = document.getElementById(`Badges-${this.dataset.section}`);
            if (badgesSource && badgesDestination) {
              badgesDestination.innerHTML = badgesSource.innerHTML;
            }

            const price = document.getElementById(`price-${this.dataset.section}`);
            if (price) price.classList.remove('hidden');

            if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

            const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
              data: {
                sectionId,
                html,
                variant: this.currentVariant,
              },
            });

            if (this.currentVariant.available) {
              this.toggleAddButton(false, '', true);
            }
            

          });
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(`product-form-${this.dataset.section}`);
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          addButtonText.textContent = FoxTheme.variantStrings.addToCart;
        }

        if (!modifyClass) return;
      }
            
      setUnavailable() {
        const button = document.getElementById(`product-form-${this.dataset.section}`);
        const addButton = button.querySelector('[name="add"]');
        const addButtonText = button.querySelector('[name="add"] > span');
        const price = document.getElementById(`price-${this.dataset.section}`);
        const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
        const sku = document.getElementById(`Sku-${this.dataset.section}`);

        if (!addButton) return;
        addButtonText.textContent = FoxTheme.variantStrings.unavailable;
        if (price) price.classList.add('hidden');
        if (inventory) inventory.classList.add('hidden');
        if (sku) sku.classList.add('hidden');
      }

      getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }
    }
  );
}
